import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation, Inject, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material';
import { Observable, merge, fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

import { RecentSearchesService } from '../../../search/shared/recent-searches.service';
import { MenuService } from '../../header/menu/menu.service';
import { MenuSubMenu } from '../../menu/menu-sub-menu.model';
import { Menu } from '../../menu/menu.model';
import { AuthUser } from '../../../core/auth/auth-frame/auth-user.model';
import { AuthService } from '../../../core/auth/auth.service';
import { LanguageService } from '../../../core/language/language.service';
import { ItauUserIdleService } from '@app/core/security/itau-user-idle.service';
import { SessionService } from '@app/core/session/session.service';
import { SearchService } from '@app/search/shared/search.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { Router } from '@angular/router';
import { detailFromBreadcrumb, normalizePath, normalizePathFromBreadcrumb } from '@app/shared/utils';


@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css'],
  encapsulation: ViewEncapsulation.None,
})

export class SearchBarComponent implements OnInit {

  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  @ViewChild('headerSearchBar') headerSearchBarElement: ElementRef;
  @ViewChild('searchIcon') searchIcon: ElementRef;

  @Input() mobile: boolean;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() key: string;
  @Input() initialTabindex: number;
  @Output() isFocused: EventEmitter<any> = new EventEmitter<any>();
  @Output() submitted: EventEmitter<boolean> = new EventEmitter<boolean>();

  recentSearchesList: Array<MenuSubMenu>;
  subMenus: Array<MenuSubMenu>;
  searchForm: FormGroup;
  searchFormChange$: Observable<any>;
  btnSearchClose: HTMLElement;
  menus: Array<Menu>;
  flgShow: boolean = true;
  isSearch: boolean = false;
  private authUser: AuthUser;
  authSubject: Observable<AuthUser>;



  constructor(private fb: FormBuilder, private recentSearchesService: RecentSearchesService, private menuService: MenuService,
    private authService: AuthService, @Inject('Window') private _window: Window, private languageService: LanguageService,
    private itauUserIdleService: ItauUserIdleService,
    private sessionService: SessionService,
    private searchService: SearchService,
    private _sdkAnalyticsService: SdkAnalyticsService, private router: Router) {
  }

  ngOnInit() {
    this.authSubject = this.authService.getAuthModel();
    this.authSubject.subscribe((user: AuthUser) => {
      this.authUser = user;
    });

    this.searchForm = this.fb.group({
      searchTerm: null
    });

    this.subMenus = this.selectAutocompleteList([]);
    this.watchSearchQueryChanges();
    this.menuService.getMenu().subscribe(menu => {
      this.menus = menu;
      if (menu)
        this.getRecentSearches();
    });
  }

  onSubmit(f: NgForm): void {

    f.value.searchTerm = f.value.searchTerm !== null ? f.value.searchTerm.trim() : '';

    if (f.value.searchTerm == '' || !this.flgShow)
      return;

    this.autocomplete.closePanel();
    this.submitted.emit(true);
    this.menuService.searchFor(f.value.searchTerm);
    this.searchService.setSearchbarTabindex(9);
  }

  watchSearchQueryChanges() {
    this.searchFormChange$ = this.searchForm.get('searchTerm').valueChanges
      .pipe(
        debounceTime(100),
        map(value => this.filterMenu(value))
      );

    this.searchFormChange$.subscribe((filteredList: Array<MenuSubMenu>) => {
      this.subMenus = this.selectAutocompleteList(filteredList);
    });
  }

  onOpenOptions(): void {
    let items = document.getElementsByClassName('mat-form-field-outline-end');

    while (items.length > 0) {
      items[0].className = 'mat-form-field-outline-end-focused-custom';
    }

    this.isFocused.emit(true);
  }

  onCloseOptions(): void {
    let items = document.getElementsByClassName('mat-form-field-outline-end-focused-custom');

    while (items.length > 0) {
      items[0].className = 'mat-form-field-outline-end';
    }

    this.isFocused.emit(false);
  }

  selectAutocompleteList(filteredSearchResults: Array<MenuSubMenu>): Array<MenuSubMenu> {
    let inputElement: any = this.headerSearchBarElement.nativeElement;
    if (inputElement.value.trim() === '') {
      return this.recentSearchesList;
    }
    return filteredSearchResults;
  }

  clearSearchField() {
    this.searchForm.get('searchTerm').setValue('');
  }

  getRecentSearches(): void {
    this.recentSearchesService.getUpdatedRecentSearches().subscribe(search => {
      this.recentSearchesList = search;
      if (!this.subMenus) {
        this.subMenus = this.recentSearchesList;
      }
    });
  }

  filterMenu(value: string): Array<MenuSubMenu> {
    if (!value) {
      this.isSearch = false;
      this.flgShow = true;
      return null;
    }
    const filterValue = value.toLowerCase();

    if (this.menus) {
      this.menuService.getPath();
      this.isSearch = true;
      this.flgShow = true;
      this.subMenus = [];
      let resultSubMenu = this.menuService.filterMenu(filterValue);
      if (resultSubMenu) {
        resultSubMenu.slice(0, 5).forEach(x => {
          this.subMenus.push(x);
        });
      }
      this.flgShow = this.subMenus.length > 0;
    }

    return this.subMenus;
  }

  get searchTermLength() {
    let inputElement: any = this.headerSearchBarElement.nativeElement;
    return inputElement.value.trim().length;
  }

  get searchTermIsLengthy() {
    if (!this.searchForm.get('searchTerm').value)
      return false;

    return this.searchForm.get('searchTerm').value.length > 0;
  }

  redirectPage() {
    let inputElement: any = this.headerSearchBarElement.nativeElement;
    let pageName = inputElement.value.toLowerCase();
    let sub = this.subMenus.filter(sm => this.languageService.translate(sm.translationKey).includes(pageName))[0];


    if (sub.path && this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: detailFromBreadcrumb(sub.path, 'resultado-busca:')
      });
    }

    if (sub.tipoMenu != 5) {
      this.itauUserIdleService.stopWatching();
      this.sessionService.updateSession().subscribe(() => { });

      var sUrl = this.authUser.serverEstatisticas + '?xyz=0';

      try {
        let userType = this.authUser.tipo == 1 ? "A" : "C"
        sUrl += this.getQueryString(this.authUser.token, this.authUser.idSessao, this.authUser.idConexao, this.authUser.gestor, this.authUser.name, userType);
        sUrl += this.getQueryStringFunction(sub.id);
        var windowOK4 = this._window.open(sUrl, name, 'directories=no,resizable=1,location=no,scrollbars=yes,height=560,width=790,left=5,top=5');
        this.itauUserIdleService.setCustomActivityEvents(
          merge(
            fromEvent(window, 'mousemove'),
            fromEvent(window, 'resize'),
            fromEvent(document, 'keydown'),
            fromEvent(document, 'touchstart'),
            fromEvent(document, 'touchend'),
            fromEvent(windowOK4, 'mousemove'),
            fromEvent(windowOK4, 'resize')
          ));
        this.itauUserIdleService.startWatching();
        if (sub.path) {
          this._sdkAnalyticsService.trackEvent('screen_view', {
            custom_path: normalizePathFromBreadcrumb(sub.path, { prefix: '/iss/lg/' }),
            implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
            detail: detailFromBreadcrumb(sub.path, 'resultado-busca:')
          });
        }
      }
      catch (ex) {
        throw ex;

      }
    }
    else {
      this.openModalContext(sub.url);
    }
  }

  private openModalContext(url) {
    this.menuService.openContext(url);
  }

  private getQueryStringFunction(codFunction) {
    try {
      return '&iDFuncao=' + (-1 * codFunction);
    }
    catch (ex) {
      throw ex;
    }
  }

  private getQueryString(token, idConnection, idSession, sGestor, nameUser, userType) {
    try {
      return '&sessao=' + token +
        '&id=' + idConnection +
        '&idsessao=' + idSession +
        '&gestor=' + sGestor +
        '&nomeUsu=' + nameUser +
        '&tipousu=' + userType;
    }
    catch (ex) {
      throw ex;
    }
  }
}
